import { useState } from 'react'
import Divider from '../../../components/Divider'
import DashboardWrapper from '../../Dashboard/components/DashboardWrapper'
import ListOfVideoTalents from '../ListOfVideoTalents/ListOfVideoTalents'
import Filters from './components/Filters'
import { IS_ADMIN } from '../../../utils/constants'

const MasterModule = () => {
  const [tabBarValue, setTabBarValue] = useState('Pendientes')
  return (
    <DashboardWrapper
      dashboardWrapperClassName="w-100"
      showTitle
      title="Hutrit Club - Talentos"
    >
      <Divider className="bg-on-bg-primary h-1 w-100 mt-3 mb-3" />
      {IS_ADMIN && (
        <Filters tabBarValue={tabBarValue} setTabBarValue={setTabBarValue} />
      )}
      <ListOfVideoTalents tabBarValue={tabBarValue} />
    </DashboardWrapper>
  )
}

export default MasterModule
